import { INDIVIDUAL } from './_http';
import { queryString } from '../../helpers';

const getNumbers = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Home/GetPensionTotalAccumulationInput`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getCustomerPolicies = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/CustomerPolicies/GetCustomerPolicies`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getBesAccumulationInfo = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Individual/GetBesAccumulationInfo?${queryString(form)}`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getCities = () => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Agito/H4AParams/Cities`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getDistricts = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Agito/H4AParams/Cities/${form.cityId}`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getHealtCenterTypes = () => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Agito/H4AParams/HealthCenterTypes`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getHealthCenters = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Agito/H4AParams/HealthCenters?${queryString(form)}`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getPersonsInPolicy = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Agito/Policies/${form.policy}?ShowOnlyCustomerId=${form.customer}`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getUser = () => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get('/Authentication/User')
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const updateUser = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post('/Authentication/UpdateUserInfo', form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const significantEnhancements= (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Notification/SignificantEnhancements?${queryString(form)}`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const getNotifications= (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Notification/GetNotification?TCKN=${form.TCKN}&Channel=INT`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const updateNotifications= (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Notification/UpdateNotification`,form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const getAppVariables= (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Home/GetAppVariables`,form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
export { getNumbers, getCustomerPolicies, getBesAccumulationInfo, getCities, getDistricts, getHealtCenterTypes, getHealthCenters, getPersonsInPolicy, getUser, updateUser,significantEnhancements,getNotifications,updateNotifications,getAppVariables }